module.exports = "img/prac-info-slide-8.0b73e0.jpeg";